import * as React from "react";
import {
  Button,
  FormControlLabel,
  FormHelperText,
  Grid,
  LinearProgress,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Controller, useForm } from "react-hook-form";
import useStyles from "./styles";
import api from '../../store/api';
import { kMaxLength } from "buffer";
import { Alert } from "@material-ui/lab";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";

interface SelectItem extends React.Props<any> {
  text: string | undefined,
  value: string | undefined,
  selected: boolean,
  disabled: boolean | undefined
};

interface RepricingToolProps {
  setLoading: any;
}
function RepricingTool(props: RepricingToolProps) {
  const {setLoading} = props;
  const classes = useStyles();
  const { handleSubmit, control, formState, errors, getValues,setValue } = useForm();
  const [customerList, setCustomerList] = React.useState<SelectItem[]>([]);
  const [locationList, setLocationList] = React.useState<SelectItem[]>([]);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [statusMessage, setStatusMessage] = React.useState("");
  
  const onSubmit = async () => {
    setLoading(true)
    setStatusMessage("");
    setErrorMessage("");
    let values = getValues();
    let customerid = values["customer"]!==''?values["customer"]:null;
    let locationid = values["location"]!==''?values["location"]:null;
    const _res = await api.updateRepricing('customerId=' + customerid +'&locationId='+locationid+'&days='+values["days"]+'&excecutionType='+values["recalculate"]);
    if(!_res.hasError)
      {
         setValue("customer",'');
         setValue("location",'');
         setValue("days",'');
         setStatusMessage(_res?.result)
      }
      else if(_res.hasError){
        setErrorMessage(_res?.result)
      }
      setLoading(false)
  };

  React.useEffect(() =>{
    getCustomer();
  },[])

  const getLocationsPerCustomer = async (customerId: string): Promise<void> => {
    if(customerId === ""){
      setLocationList([]);
      return;
    }
    try {
      setLoading(true)
      const _res = await api.getLocationsPerCustomer('customerId=' + customerId);
      if (_res !== null && _res.data !== null && _res.data.model !== null) {
        setLocationList(_res.data.model);
      } 
      setLoading(false)
    }
    catch (error) {
      setErrorMessage("Error occurs in getting location Per Customer...")
      setLocationList([]);
      setLoading(false)
    }
  }

const getCustomer = async (): Promise<void> => {
  try {
    setLoading(true)
      const _res = await api.getCustomer('');
      if (_res !== null && _res.data !== null && _res.data.result !== null) {        
          setCustomerList(_res.data.result);  
          setLoading(false)     
      }
  }
  catch(error) {
      setErrorMessage("Error occurs in getting Customer...")
      setLocationList([]);
      setLoading(false)
  }
}

const selectChangedHandler = (value: any) => {
  setStatusMessage("");
  setErrorMessage("");
  setValue("customer",value);
  setValue("location",'');
  getLocationsPerCustomer(value);
}

  const Changedays = (value: number) => {
    if (value <= 120)
      setValue("days", value);
    if (value === 0)
      setValue("days", '');
  }
  return (
    <div className={classes.repricingTool}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ width: "100%" }}
        autoComplete="off"
      >
        <Grid container spacing={3} className={"formContainer"}>
          <Grid item xs={12}>
            <div className={"formLabel"}>Re-calculate:</div>
          </Grid>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="recalculate"
              defaultValue={"1"}
              render={(props) => (
                <RadioGroup {...props} className={"radioInput"}>
                  <FormControlLabel
                    control={<Radio size="small" />}
                    label="Unpriced Transfers"
                    value="1"
                  />
                  <FormControlLabel
                    control={<Radio size="small" />}
                    label="All Transfers"
                    value="2"
                  />
                </RadioGroup>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={"inlineField"}>
              <div className={"formSubLabel"}>
                Completed/aborted/cancelled in last
              </div>
              <div className={"inlineTextbox"}>
                <Controller
                  control={control}
                  name="days"
                  defaultValue={""}
                  render={(props) => (
                    <TextField
                      {...props}
                      className={"textFieldInput"}
                      variant="outlined"
                      onChange={e => Changedays(Number(e.target.value))}
                      inputProps={{ min: 0, max: 120 }}
                      error={errors.days}
                    />

                  )}
                  rules={{
                    required: "The days field is required"
                  }}
                />
                <div className={"formSubLabel"}>days</div>
              </div>
            </div>
            {Boolean(errors.days) && (<div>
              <FormHelperText error={true} style={{ textAlign: "right" }}>
                {errors.days.message}
              </FormHelperText>
            </div>)}
          </Grid>
          <Grid item xs={12}>
            <div className={"inlineField"}>
              <div className={"formSubLabel"}>For</div>
              <div className={"inlineSelectbox"}>
                <Controller
                  control={control}
                  name="customer"
                  defaultValue={""}
                  render={(props) => (
                    <Select
                      {...props}
                      className={"selectFieldInput"}
                      variant="outlined"
                      IconComponent={KeyboardArrowDownIcon}
                      displayEmpty
                      onChange={e => selectChangedHandler(e.target.value)}
                      error={errors.for}
                    >
                      <MenuItem key="None" value={''}>Any Customer</MenuItem >
                      {customerList.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </div>
            </div>
            <div className={"inlineField"}>
              <div className={"formSubLabel"}>Booked by</div>
              <div className={"inlineSelectbox"}>
                <Controller
                  control={control}
                  name="location"
                  defaultValue={""}
                  render={(props) => (
                    <Select
                      {...props}
                      className={"selectFieldInput"}
                      variant="outlined"
                      IconComponent={KeyboardArrowDownIcon}
                      displayEmpty
                      error={errors.booked_by}
                    >
                      <MenuItem key="None" value={''}>Any Location</MenuItem >
                      {locationList.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={"formBtnBox"}>
              <Button
                type="submit"
                disabled={formState.isSubmitting}
                className={"formSubmit"}
                variant="contained"
                color="primary"
              >
                Run
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className={classes.main} style={{ paddingRight: 40 }}>
          <div className={classes.headingAlert}>
            <Alert
              variant="filled"
              icon={<ReportProblemOutlinedIcon />}
              severity="error"
              classes={{ root: classes.alertRoot }}
              style={{ display: errorMessage ? "flex" : "none" }}
            >
              {errorMessage}
            </Alert>
            <Alert
              variant="filled"
              icon={<InfoIcon />}
              severity="success"
              classes={{ root: classes.alertRoot }}
              style={{ display: statusMessage ? "flex" : "none" }}
            >
              {statusMessage}
            </Alert>
          </div>
        </div>
      </form>
    </div>
  );
};

export default React.memo(RepricingTool);

const forList = [
  { value: 1, text: "Any Customer" },
  { value: 2, text: "Any User" },
];

const bookedByList = [
  { value: 1, text: "Any Location" },
  { value: 2, text: "Any Customer" },
];
